<template>
    <section class="xxl:d-none">
        <div class="sidebar menu__nav text-dark-1">
            <!-- <div v-if="loading" class="loading-indicator">
                <Loader />
            </div> -->
            <div>
                <!-- Back Button -->
                <div v-if="submenuHistory.length > 0" class="back-button menu__backButton menu-item" @click="goBack">
                    <span>
                        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="m9 5 7 7-7 7" />
                        </svg>
                    </span>
                    Back
                </div>

                <!-- Dynamic Menu Rendering -->
                <ul class="menu subnav">
                    <li v-show="showOld">
                        <div class="menu-item exact">
                            <router-link to="/"> {{ $t('menu.home') }} </router-link>
                        </div>
                    </li>

                    <li v-for="(item, index) in currentMenu" :key="index"
                        @click="item.children && item.children.length !== 0 ? openSubmenu(item) : goToFilteredCoureses(item.value)"
                        :data-show="true">
                        <div class="menu-item exact">
                            <router-link :to="item.pageLink" v-if="item.pageLink">{{ item.label }}</router-link>
                            <span v-else>{{ item.label }} </span>
                            <span v-if="item.children.length !== 0" class="arrow rotate-svg">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="m9 5 7 7-7 7" />
                                </svg>
                            </span>
                        </div>
                    </li>

                    <li v-show="showOld">
                        <div class="menu-item exact">
                            <router-link to="/about"> {{ $t('menu.about_us') }} </router-link>
                        </div>
                    </li>
                    <li v-show="showOld">
                        <div class="menu-item exact" v-if="isAuthenticated">
                            <a :href="learningLink" class="text-capitalize">{{ $t('my_learning') }}</a>
                        </div>
                    </li> 
                    <li v-show="showOld">
                        <div class="menu-item exact">
                            <router-link to="/courses"> {{ $t('menu.courses') }} </router-link>
                        </div>
                    </li>
                    <!-- <li v-show="showOld">
                        <div class="menu-item exact">
                            <router-link to="/events"> {{ $t('menu.events') }} </router-link>
                        </div>
                    </li> -->

                    <!----<li v-show="showOld">
                        <div class="menu-item exact">
                            <router-link to="/blogs"> {{ $t('menu.blogs') }} </router-link>
                        </div>
                    </li>-->
                    <li v-show="showOld">
                        <div class="menu-item exact" v-if="isAuthenticated">
                            <router-link to="/join-us"> {{ $t('menu.teach_with_us') }} </router-link>
                        </div>
                    </li>

                    <li v-show="showOld">
                        <div class="menu-item exact">
                            <router-link to="/certificate"> {{ $t('menu.verify_certificate') }} </router-link>
                        </div>
                    </li>

                    <li v-show="showOld">
                        <div class="menu-item exact">
                            <router-link to="/contact"> {{ $t('menu.contact_us') }} </router-link>
                        </div>
                    </li>
                                  
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
//import Loader from "../common/Loader.vue";
import AOS from "aos";
import { mapGetters } from "vuex";
export default {
    props:['learningLink'],
    components: {
       // Loader
    },
    label: "SidebarMenu",
    data() {
        return {
            submenuHistory: [], // Stack to keep track of previous menus
            currentMenu: [], // Current menu being displayed
            loading: true,
            showOld: true,
            //categories: [],
        };
    },
    methods: {
        goToFilteredCoureses(val) {
            this.$store.commit('setSelectedCategories', [val]);
            this.$router.push('/courses');
        },
        openSubmenu(item) {
            if (item.children) {
                // Save the current menu to the history
                this.submenuHistory.push(this.currentMenu);
                // Display the clicked submenu
                this.currentMenu = item.children;
                this.showOld = false
            }
        },
        // Recursive function to map categories and their children
        mapCategories(categories) {
            return categories.map(category => {
                const categoryItem = {
                    label: category.name,
                };
                // If the category has children, recursively map them
                if (category.children && category.children.length > 0) {
                    categoryItem.children = this.mapCategories(category.children);
                }
                return categoryItem;
            });
        },
        goBack() {
            // Return to the previous menu by popping from history
            if (this.submenuHistory.length > 1) {
                this.currentMenu = this.submenuHistory.pop();
            } else if (this.submenuHistory.length === 1) {
                // If this is the last step back, show the old menu
                this.currentMenu = this.submenuHistory.pop();
                this.showOld = true;
            }
        },
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
        categories() {
            return this.$store.getters.categories
        },
        menu() {
            return [
                {
                    label: this.$t('menu.discover'),
                    children: [
                        {
                            label: this.$t('menu.categories'),
                            children: this.categories,
                        },
                    ],
                },
            ];
        },
        ...mapGetters(["currentLanguage"]),
    },
    watch: {
        currentLanguage(newLocale) {
            this.currentMenu = this.menu;
            this.$store.dispatch('categoriesList');
        },
        categories(newCategories) {
            if (newCategories.length > 0) {
                this.loading = false; // Categories have been loaded
                this.currentMenu = this.menu; // Set the current menu with the loaded categories
            }
        },
    },
    mounted() {
       // this.$store.dispatch('categoriesList');
        // Initialize with the top-level menu
        this.currentMenu = this.menu;
        AOS.init({
            duration: 1000, // Animation duration
            once: true, // Whether animation should happen only once
        });
    },

};
</script>

<style lang="scss" scoped>
@-webkit-keyframes fadeInup {
    0% {
        opacity: 0;
        -webkit-transform: translateY(-20px);
        transform: translateY(-20px);
    }

    100% {
        opacity: 1;
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
}

@keyframes fadeInup {
    0% {
        opacity: 0;
        -webkit-transform: translateY(-20px);
        transform: translateY(-20px);
    }

    100% {
        opacity: 1;
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
}

.sidebar {
    background: #f9f9ff;
    max-height: 53vh;
    overflow-y: auto;
}

.header .header-menu .menu::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 5px;
}

/* Style the scrollbar thumb */
.header .header-menu .menu::-webkit-scrollbar-thumb {
    background: #09445d;
    border-radius: 10px;
    border: 2px solid #f0f0f0;
}

/* Style the scrollbar thumb when hovered */
.header .header-menu .menu::-webkit-scrollbar-thumb:hover {
    background: #7c929b;
}

/* Set the scrollbar width */
.header .header-menu .menu::-webkit-scrollbar {
    width: 16px;
}

.menu {
    list-style: none;
    padding: 0;
    margin: 0;
    -webkit-animation: fadeInup 1s linear;
    animation: fadeInup 1s linear;
}

.menu-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 15px 15px;
    cursor: pointer;
    color: #09445d;
    font-size: 16px;
    -webkit-transition: 0.2s ease-in-out;
    -o-transition: 0.2s ease-in-out;
    transition: 0.2s ease-in-out;

    &:lang(en) {
        text-align: left;
    }

    &:lang(ar) {
        text-align: right;
    }
}

.menu-item:hover {
    background-color: #e9eeefc3;
}

.arrow {
    font-size: 0.8rem;
}

.back-button {
    padding: 10px 15px;
    margin: 5px 20px;
    cursor: pointer;
    background: #9bb2c01c;
    color: #09445d;
    border-bottom: none;

    &:lang(en) {
        svg {
            -webkit-transform: scaleX(-1);
            -ms-transform: scaleX(-1);
            transform: scaleX(-1);
        }
    }
}

.back-button:hover {
    background-color: #9bb2c07d;
}
</style>